import styles from "./styles/ProjectsHeader.module.scss";

export default function ProjectsHeader() {
  return (
    <>
      <span className={styles.header}>پروژه ها</span>
    </>
  );
}
